import { Mapper } from '../../../common/ddd/mapper.base';
import { formatDeviation } from '../../../common/utils/format-deviation.util';
import { formatDuration } from '../../../common/utils/format-duration.util';
import { SelfCalendarScoreAggregateRoot } from '../../../core/domain/aggregates/scores/self-calendar-score.aggregate-root';
import { GetSelfCalendarScoreResponseDto } from '../../../interface/dtos/scores/get-calendar-score-response.dto';

export type ISelfCalendarScoreAggregateRootMapper = Mapper<
  SelfCalendarScoreAggregateRoot,
  GetSelfCalendarScoreResponseDto
>;

export class SelfCalendarScoreAggregateRootMapper
  implements Omit<ISelfCalendarScoreAggregateRootMapper, 'toDomain'>
{
  toResponse(
    entity: SelfCalendarScoreAggregateRoot
  ): GetSelfCalendarScoreResponseDto {
    return SelfCalendarScoreAggregateRootMapper.toResponse(entity);
  }

  static toResponse(
    entity: SelfCalendarScoreAggregateRoot
  ): GetSelfCalendarScoreResponseDto {
    return {
      value: formatDuration(entity.totalTime),
      unformattedValue: entity.totalTime,
      count: entity.count,
      averagePerEvent: formatDuration(entity.averagePerEvent),
      deviationFromAveragePercentage: formatDeviation(
        entity.deviationFromAveragePercentage
      ),
      name: entity.name,
    };
  }
}
